module.exports = function() {
    $('body').on('click', '.select-box-heading', function() {
        var filterWrapper = $('.filter-wrapper');
        $('.navigation-list').toggleClass('d-none');
        $('.select-box-heading').toggleClass('active');
        if ($(this).hasClass('active')) {
            filterWrapper.addClass('display-order-filter');
        } else {
            filterWrapper.removeClass('display-order-filter');
        }
    });

    $(document).on('click', function (e) {
        if (!$('.select-box-heading').is(e.target) && !$('.select-box-heading').find('*').is(e.target)) {
            var filterWrapper = $('.filter-wrapper');
            $('.navigation-list').addClass('d-none');
            $('.select-box-heading').removeClass('active');
            filterWrapper.removeClass('display-order-filter');
        }
    });
}
